// Generated by scripts/generate-public-surface.ts. Do not edit.
export { default as tckimlik } from "./tckimlik";
export { default as vkn } from "./vkn";
